/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateCustomReportDto,
  CustomReportsResponseDto,
  DomainErrorDto,
  GetWorkOrderFilterColumnsResponseDto,
  GetWorkOrderRelatedItemsResponseDto,
  GetWorkOrderReportsResponseDto,
  GetWorkOrderResponseDto,
  GetWorkOrdersResponseDto,
  UpdateCustomReportDto,
  UpdateWorkOrderWatchDto,
  WorkOrderControllerGetWorkOrdersParams,
  WorkOrderWatchStateDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType , BodyType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const workOrderControllerGetWorkOrders = (
    params?: WorkOrderControllerGetWorkOrdersParams,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetWorkOrdersResponseDto>(
      {url: `/api/v1/account/work-order`, method: 'GET',
        params, signal
    },
      options);
    }




export const getWorkOrderControllerGetWorkOrdersQueryKey = (params?: WorkOrderControllerGetWorkOrdersParams,) => {
    return [
    `/api/v1/account/work-order`, ...(params ? [params] : [])
    ] as const;
    }


export const getWorkOrderControllerGetWorkOrdersQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(params?: WorkOrderControllerGetWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>> = ({ signal }) => workOrderControllerGetWorkOrders(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>>
export type WorkOrderControllerGetWorkOrdersQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetWorkOrders<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  WorkOrderControllerGetWorkOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrders<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: WorkOrderControllerGetWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrders<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: WorkOrderControllerGetWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrders<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: WorkOrderControllerGetWorkOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getWorkOrderControllerGetWorkOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(params?: WorkOrderControllerGetWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>> = ({ signal }) => workOrderControllerGetWorkOrders(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>>
export type WorkOrderControllerGetWorkOrdersSuspenseQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 params: undefined |  WorkOrderControllerGetWorkOrdersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: WorkOrderControllerGetWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: WorkOrderControllerGetWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrdersSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError = ErrorType<DomainErrorDto>>(
 params?: WorkOrderControllerGetWorkOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrders>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrdersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const workOrderControllerGetWorkOrderFilterColumns = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetWorkOrderFilterColumnsResponseDto>(
      {url: `/api/v1/account/work-order/filter-columns`, method: 'GET', signal
    },
      options);
    }




export const getWorkOrderControllerGetWorkOrderFilterColumnsQueryKey = () => {
    return [
    `/api/v1/account/work-order/filter-columns`
    ] as const;
    }


export const getWorkOrderControllerGetWorkOrderFilterColumnsQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderFilterColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>> = ({ signal }) => workOrderControllerGetWorkOrderFilterColumns(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderFilterColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>>
export type WorkOrderControllerGetWorkOrderFilterColumnsQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetWorkOrderFilterColumns<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderFilterColumns<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderFilterColumns<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderFilterColumns<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderFilterColumnsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getWorkOrderControllerGetWorkOrderFilterColumnsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderFilterColumnsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>> = ({ signal }) => workOrderControllerGetWorkOrderFilterColumns(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderFilterColumnsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>>
export type WorkOrderControllerGetWorkOrderFilterColumnsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetWorkOrderFilterColumnsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderFilterColumnsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderFilterColumnsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderFilterColumnsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderFilterColumns>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderFilterColumnsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const workOrderControllerGetWorkOrderReports = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetWorkOrderReportsResponseDto>(
      {url: `/api/v1/account/work-order/reports`, method: 'GET', signal
    },
      options);
    }




export const getWorkOrderControllerGetWorkOrderReportsQueryKey = () => {
    return [
    `/api/v1/account/work-order/reports`
    ] as const;
    }


export const getWorkOrderControllerGetWorkOrderReportsQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>> = ({ signal }) => workOrderControllerGetWorkOrderReports(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderReportsQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>>
export type WorkOrderControllerGetWorkOrderReportsQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetWorkOrderReports<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderReports<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderReports<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderReports<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderReportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getWorkOrderControllerGetWorkOrderReportsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>> = ({ signal }) => workOrderControllerGetWorkOrderReports(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderReportsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>>
export type WorkOrderControllerGetWorkOrderReportsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetWorkOrderReportsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderReportsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderReportsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderReportsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderReportsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const workOrderControllerGetCustomReports = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<CustomReportsResponseDto>(
      {url: `/api/v1/account/work-order/custom-reports`, method: 'GET', signal
    },
      options);
    }




export const getWorkOrderControllerGetCustomReportsQueryKey = () => {
    return [
    `/api/v1/account/work-order/custom-reports`
    ] as const;
    }


export const getWorkOrderControllerGetCustomReportsQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetCustomReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>> = ({ signal }) => workOrderControllerGetCustomReports(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetCustomReportsQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>>
export type WorkOrderControllerGetCustomReportsQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetCustomReports<TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetCustomReports<TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetCustomReports<TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetCustomReports<TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetCustomReportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getWorkOrderControllerGetCustomReportsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetCustomReportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>> = ({ signal }) => workOrderControllerGetCustomReports(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetCustomReportsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>>
export type WorkOrderControllerGetCustomReportsSuspenseQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetCustomReportsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetCustomReportsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetCustomReportsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetCustomReportsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetCustomReports>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetCustomReportsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const workOrderControllerCreateCustomReport = (
    createCustomReportDto: BodyType<CreateCustomReportDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<CustomReportsResponseDto>(
      {url: `/api/v1/account/work-order/custom-reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomReportDto, signal
    },
      options);
    }



export const getWorkOrderControllerCreateCustomReportMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerCreateCustomReport>>, TError,{data: BodyType<CreateCustomReportDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerCreateCustomReport>>, TError,{data: BodyType<CreateCustomReportDto>}, TContext> => {

const mutationKey = ['workOrderControllerCreateCustomReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrderControllerCreateCustomReport>>, {data: BodyType<CreateCustomReportDto>}> = (props) => {
          const {data} = props ?? {};

          return  workOrderControllerCreateCustomReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrderControllerCreateCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerCreateCustomReport>>>
    export type WorkOrderControllerCreateCustomReportMutationBody = BodyType<CreateCustomReportDto>
    export type WorkOrderControllerCreateCustomReportMutationError = ErrorType<DomainErrorDto>

    export const useWorkOrderControllerCreateCustomReport = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerCreateCustomReport>>, TError,{data: BodyType<CreateCustomReportDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrderControllerCreateCustomReport>>,
        TError,
        {data: BodyType<CreateCustomReportDto>},
        TContext
      > => {
      return useMutation(getWorkOrderControllerCreateCustomReportMutationOptions(options), queryClient);
    }
    export const workOrderControllerUpdateCustomReport = (
    reportId: string,
    updateCustomReportDto: BodyType<UpdateCustomReportDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<CustomReportsResponseDto>(
      {url: `/api/v1/account/work-order/custom-reports/${reportId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomReportDto, signal
    },
      options);
    }



export const getWorkOrderControllerUpdateCustomReportMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerUpdateCustomReport>>, TError,{reportId: string;data: BodyType<UpdateCustomReportDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerUpdateCustomReport>>, TError,{reportId: string;data: BodyType<UpdateCustomReportDto>}, TContext> => {

const mutationKey = ['workOrderControllerUpdateCustomReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrderControllerUpdateCustomReport>>, {reportId: string;data: BodyType<UpdateCustomReportDto>}> = (props) => {
          const {reportId,data} = props ?? {};

          return  workOrderControllerUpdateCustomReport(reportId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrderControllerUpdateCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerUpdateCustomReport>>>
    export type WorkOrderControllerUpdateCustomReportMutationBody = BodyType<UpdateCustomReportDto>
    export type WorkOrderControllerUpdateCustomReportMutationError = ErrorType<DomainErrorDto>

    export const useWorkOrderControllerUpdateCustomReport = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerUpdateCustomReport>>, TError,{reportId: string;data: BodyType<UpdateCustomReportDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrderControllerUpdateCustomReport>>,
        TError,
        {reportId: string;data: BodyType<UpdateCustomReportDto>},
        TContext
      > => {
      return useMutation(getWorkOrderControllerUpdateCustomReportMutationOptions(options), queryClient);
    }
    export const workOrderControllerDeleteCustomReport = (
    reportId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<void>(
      {url: `/api/v1/account/work-order/custom-reports/${reportId}`, method: 'DELETE', signal
    },
      options);
    }



export const getWorkOrderControllerDeleteCustomReportMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerDeleteCustomReport>>, TError,{reportId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerDeleteCustomReport>>, TError,{reportId: string}, TContext> => {

const mutationKey = ['workOrderControllerDeleteCustomReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrderControllerDeleteCustomReport>>, {reportId: string}> = (props) => {
          const {reportId} = props ?? {};

          return  workOrderControllerDeleteCustomReport(reportId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrderControllerDeleteCustomReportMutationResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerDeleteCustomReport>>>

    export type WorkOrderControllerDeleteCustomReportMutationError = ErrorType<DomainErrorDto>

    export const useWorkOrderControllerDeleteCustomReport = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerDeleteCustomReport>>, TError,{reportId: string}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrderControllerDeleteCustomReport>>,
        TError,
        {reportId: string},
        TContext
      > => {
      return useMutation(getWorkOrderControllerDeleteCustomReportMutationOptions(options), queryClient);
    }
    export const workOrderControllerGetWorkOrderWatchState = (
    workOrderId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<WorkOrderWatchStateDto>(
      {url: `/api/v1/account/work-order/${workOrderId}/watch`, method: 'GET', signal
    },
      options);
    }




export const getWorkOrderControllerGetWorkOrderWatchStateQueryKey = (workOrderId: string,) => {
    return [
    `/api/v1/account/work-order/${workOrderId}/watch`
    ] as const;
    }


export const getWorkOrderControllerGetWorkOrderWatchStateQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderWatchStateQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>> = ({ signal }) => workOrderControllerGetWorkOrderWatchState(workOrderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderWatchStateQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>>
export type WorkOrderControllerGetWorkOrderWatchStateQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetWorkOrderWatchState<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderWatchState<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderWatchState<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderWatchState<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderWatchStateQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getWorkOrderControllerGetWorkOrderWatchStateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderWatchStateQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>> = ({ signal }) => workOrderControllerGetWorkOrderWatchState(workOrderId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderWatchStateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>>
export type WorkOrderControllerGetWorkOrderWatchStateSuspenseQueryError = ErrorType<DomainErrorDto>


export function useWorkOrderControllerGetWorkOrderWatchStateSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderWatchStateSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderWatchStateSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderWatchStateSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError = ErrorType<DomainErrorDto>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderWatchState>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderWatchStateSuspenseQueryOptions(workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const workOrderControllerUpdateWorkOrderWatchState = (
    workOrderId: string,
    updateWorkOrderWatchDto: BodyType<UpdateWorkOrderWatchDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<WorkOrderWatchStateDto>(
      {url: `/api/v1/account/work-order/${workOrderId}/watch`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkOrderWatchDto, signal
    },
      options);
    }



export const getWorkOrderControllerUpdateWorkOrderWatchStateMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerUpdateWorkOrderWatchState>>, TError,{workOrderId: string;data: BodyType<UpdateWorkOrderWatchDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerUpdateWorkOrderWatchState>>, TError,{workOrderId: string;data: BodyType<UpdateWorkOrderWatchDto>}, TContext> => {

const mutationKey = ['workOrderControllerUpdateWorkOrderWatchState'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrderControllerUpdateWorkOrderWatchState>>, {workOrderId: string;data: BodyType<UpdateWorkOrderWatchDto>}> = (props) => {
          const {workOrderId,data} = props ?? {};

          return  workOrderControllerUpdateWorkOrderWatchState(workOrderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrderControllerUpdateWorkOrderWatchStateMutationResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerUpdateWorkOrderWatchState>>>
    export type WorkOrderControllerUpdateWorkOrderWatchStateMutationBody = BodyType<UpdateWorkOrderWatchDto>
    export type WorkOrderControllerUpdateWorkOrderWatchStateMutationError = ErrorType<DomainErrorDto>

    export const useWorkOrderControllerUpdateWorkOrderWatchState = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerUpdateWorkOrderWatchState>>, TError,{workOrderId: string;data: BodyType<UpdateWorkOrderWatchDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrderControllerUpdateWorkOrderWatchState>>,
        TError,
        {workOrderId: string;data: BodyType<UpdateWorkOrderWatchDto>},
        TContext
      > => {
      return useMutation(getWorkOrderControllerUpdateWorkOrderWatchStateMutationOptions(options), queryClient);
    }
    export const workOrderControllerDeleteWorkOrderWatchState = (
    workOrderId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<WorkOrderWatchStateDto>(
      {url: `/api/v1/account/work-order/${workOrderId}/watch`, method: 'DELETE', signal
    },
      options);
    }



export const getWorkOrderControllerDeleteWorkOrderWatchStateMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerDeleteWorkOrderWatchState>>, TError,{workOrderId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerDeleteWorkOrderWatchState>>, TError,{workOrderId: string}, TContext> => {

const mutationKey = ['workOrderControllerDeleteWorkOrderWatchState'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workOrderControllerDeleteWorkOrderWatchState>>, {workOrderId: string}> = (props) => {
          const {workOrderId} = props ?? {};

          return  workOrderControllerDeleteWorkOrderWatchState(workOrderId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkOrderControllerDeleteWorkOrderWatchStateMutationResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerDeleteWorkOrderWatchState>>>

    export type WorkOrderControllerDeleteWorkOrderWatchStateMutationError = ErrorType<DomainErrorDto>

    export const useWorkOrderControllerDeleteWorkOrderWatchState = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workOrderControllerDeleteWorkOrderWatchState>>, TError,{workOrderId: string}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workOrderControllerDeleteWorkOrderWatchState>>,
        TError,
        {workOrderId: string},
        TContext
      > => {
      return useMutation(getWorkOrderControllerDeleteWorkOrderWatchStateMutationOptions(options), queryClient);
    }
    export const workOrderControllerGetWorkOrder = (
    workOrderId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetWorkOrderResponseDto>(
      {url: `/api/v1/account/work-order/${workOrderId}`, method: 'GET', signal
    },
      options);
    }




export const getWorkOrderControllerGetWorkOrderQueryKey = (workOrderId: string,) => {
    return [
    `/api/v1/account/work-order/${workOrderId}`
    ] as const;
    }


export const getWorkOrderControllerGetWorkOrderQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>> = ({ signal }) => workOrderControllerGetWorkOrder(workOrderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>>
export type WorkOrderControllerGetWorkOrderQueryError = ErrorType<DomainErrorDto | void>


export function useWorkOrderControllerGetWorkOrder<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrder<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrder<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrder<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getWorkOrderControllerGetWorkOrderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>> = ({ signal }) => workOrderControllerGetWorkOrder(workOrderId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>>
export type WorkOrderControllerGetWorkOrderSuspenseQueryError = ErrorType<DomainErrorDto | void>


export function useWorkOrderControllerGetWorkOrderSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrder>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderSuspenseQueryOptions(workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const workOrderControllerGetWorkOrderRelatedItems = (
    workOrderId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<GetWorkOrderRelatedItemsResponseDto>(
      {url: `/api/v1/account/work-order/${workOrderId}/related-items`, method: 'GET', signal
    },
      options);
    }




export const getWorkOrderControllerGetWorkOrderRelatedItemsQueryKey = (workOrderId: string,) => {
    return [
    `/api/v1/account/work-order/${workOrderId}/related-items`
    ] as const;
    }


export const getWorkOrderControllerGetWorkOrderRelatedItemsQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderRelatedItemsQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>> = ({ signal }) => workOrderControllerGetWorkOrderRelatedItems(workOrderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderRelatedItemsQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>>
export type WorkOrderControllerGetWorkOrderRelatedItemsQueryError = ErrorType<DomainErrorDto | void>


export function useWorkOrderControllerGetWorkOrderRelatedItems<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderRelatedItems<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>,
          TError,
          Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderRelatedItems<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderRelatedItems<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderRelatedItemsQueryOptions(workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getWorkOrderControllerGetWorkOrderRelatedItemsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkOrderControllerGetWorkOrderRelatedItemsQueryKey(workOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>> = ({ signal }) => workOrderControllerGetWorkOrderRelatedItems(workOrderId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkOrderControllerGetWorkOrderRelatedItemsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>>
export type WorkOrderControllerGetWorkOrderRelatedItemsSuspenseQueryError = ErrorType<DomainErrorDto | void>


export function useWorkOrderControllerGetWorkOrderRelatedItemsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderRelatedItemsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkOrderControllerGetWorkOrderRelatedItemsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWorkOrderControllerGetWorkOrderRelatedItemsSuspense<TData = Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError = ErrorType<DomainErrorDto | void>>(
 workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof workOrderControllerGetWorkOrderRelatedItems>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkOrderControllerGetWorkOrderRelatedItemsSuspenseQueryOptions(workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






